export default __webpack_public_path__ + "87e9bcae034b1d9a007da77f510b0f4c.svg";